var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0ZM9 1.63636C13.0668 1.63636 16.3636 4.93318 16.3636 9C16.3636 13.0668 13.0668 16.3636 9 16.3636C4.93318 16.3636 1.63636 13.0668 1.63636 9C1.63636 4.93318 4.93318 1.63636 9 1.63636Z",
    fill: "#2B2F68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.68778 6.13153L3.70801 6.7972L3.61358 6.82403C3.06668 7.01439 2.87888 7.7184 3.29009 8.156L5.56442 10.5759L5.03434 13.5185L5.02315 13.6052C4.97441 14.2338 5.64611 14.6926 6.22306 14.3864L8.99914 12.9126L11.7766 14.3864L11.8558 14.4235C12.4397 14.6614 13.0813 14.1613 12.9654 13.5186L12.4347 10.5759L14.7098 8.156L14.7729 8.08073C15.1183 7.61594 14.878 6.92807 14.2919 6.7972L11.3113 6.13153L9.70307 3.42715C9.38588 2.89407 8.61401 2.89408 8.29682 3.42716L6.68778 6.13153ZM8.99996 5.44507L10.0866 7.27183L10.1404 7.35126C10.2566 7.50286 10.423 7.6099 10.6114 7.65197L12.5345 8.08125L10.9605 9.75631L10.8987 9.83037C10.7657 10.0104 10.7114 10.2387 10.7516 10.4618L11.0561 12.1509L9.3835 11.2639L9.29151 11.2221C9.07255 11.1386 8.82629 11.1525 8.61642 11.2638L6.94305 12.1509L7.24834 10.4618L7.25984 10.366C7.27338 10.1425 7.19463 9.92153 7.03938 9.75631L5.4646 8.08125L7.38851 7.65197C7.60831 7.60289 7.79816 7.46537 7.91332 7.27183L8.99996 5.44507Z",
    fill: "#2B2F68"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.42361040.svg";
export { ForwardRef as ReactComponent };